/**
 * Asynchronously loads the component for ChannelSettingsComponent
 */

import { lazyLoad } from 'utils/loadable';

export const ChannelSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.ChannelSettingsComponent,
);
